import * as React from 'react';

import {Button} from 'shells/button/button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Modal} from 'shells/modal/modal';

import {getSeeMoreText} from './helpers';

type Props = {
    items: any[];
    maxVisibleItems: number;
    renderRow: (item: any, handleCloseModal?: () => void) => React.ReactElement;
    pluralNoun: string;
    modalHeader: string;
};

export function ListWithSeeMoreModal(props: Props) {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

    const hasMoreItems = props.items.length > props.maxVisibleItems;
    let visibleItems = props.items;
    if (props.items.length > props.maxVisibleItems) {
        visibleItems = props.items.slice(0, props.maxVisibleItems - 1);
    }

    const handleCloseModal = React.useCallback(() => {
        setIsModalOpen(false);
    }, []);

    return (
        <>
            <div className='flex flex-dir-col justify-sb gap-16 full-height'>
                <StackLegacy spacing={12}>
                    {visibleItems.map((item) => props.renderRow(item))}
                    {hasMoreItems && (
                        <div className='flex justify-center'>
                            <Button
                                variant='text-secondary-dark'
                                onClick={() => setIsModalOpen(true)}
                                size='tiny'
                            >
                                {getSeeMoreText(
                                    props.items.length,
                                    props.maxVisibleItems,
                                    props.pluralNoun
                                )}
                            </Button>
                        </div>
                    )}
                </StackLegacy>
            </div>
            {isModalOpen && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseModal}
                    headerText={props.modalHeader}
                    fitHeight={true}
                    maxWidth={700}
                >
                    <div className='pb-32'>
                        <StackLegacy spacing={12}>
                            {props.items.map((item) => props.renderRow(item, handleCloseModal))}
                        </StackLegacy>
                    </div>
                </Modal>
            )}
        </>
    );
}
